"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsiblePanelHeader = CollapsiblePanelHeader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../constants/icons");

var _CollapsiblePanelContext = require("../contexts/CollapsiblePanelContext");

var _Button = require("../forms/Button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function renderRollupText(rollupText) {
  if (typeof rollupText === 'function') {
    return rollupText();
  }

  return rollupText;
}

function CollapsiblePanelHeader(props) {
  var _useCollapsiblePanelC = (0, _CollapsiblePanelContext.useCollapsiblePanelContext)(),
      isCollapsed = _useCollapsiblePanelC.isCollapsed,
      onCollapse = _useCollapsiblePanelC.onCollapse;

  var rollupTextClass = isCollapsed && !props.autoHideRollupText ? 'collapsible-panel__header-rollup-text collapsible-panel__header-rollup-text--always-show' : 'collapsible-panel__header-rollup-text';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-panel__header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-panel__header-left"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    onClick: onCollapse
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "collapsible-panel__header-label"
  }, props.headerLabel), /*#__PURE__*/_react["default"].createElement("span", {
    className: "collapsible-panel__header-caret ".concat(_icons.icons.caretDown)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: rollupTextClass
  }, renderRollupText(props.rollupText)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible-panel__right"
  }, props.children));
}

CollapsiblePanelHeader.propTypes = {
  headerLabel: _propTypes["default"].string.isRequired,
  autoHideRollupText: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  rollupText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func])
};
CollapsiblePanelHeader.defaultProps = {
  autoHideRollupText: true,
  children: null,
  rollupText: ''
};